import React from 'react';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { languageMap } from '../constants';

const CaptionEditor = ({
    selectedCaptionFormat,
    setSelectedCaptionFormat,
    selectedLanguage,
    setSelectedLanguage,
    captionUrl,
    captionText,
    setCaptionText,
    loadingCaption,
    isEditingCaption,
    savingCaption,
    hasVTT,
    hasSRT,
    availableLanguages,
    onEdit,
    onSave,
    onCancel
}) => {
    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h5">Caption Text Editor</CardTitle>
                <hr />
                <Row>
                    <Col lg={6}>
                        <FormGroup>
                            <Label for="captionFormat">Caption Format</Label>
                            <Input 
                                type="select" 
                                id="captionFormat" 
                                className="form-control"
                                value={selectedCaptionFormat}
                                onChange={(e) => setSelectedCaptionFormat(e.target.value)}
                            >
                                <option value="">Select Format</option>
                                {hasVTT && (
                                    <option value="webvtt">WebVTT</option>
                                )}
                                {hasSRT && (
                                    <option value="srt">SRT</option>
                                )}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col lg={6}>
                        <FormGroup>
                            <Label for="selectLanguage">Select Language</Label>
                            <Input 
                                type="select" 
                                id="selectLanguage" 
                                className="form-control"
                                value={selectedLanguage}
                                onChange={(e) => setSelectedLanguage(e.target.value)}
                            >
                                <option value="">Select Language</option>
                                {availableLanguages.map(lang => (
                                    <option key={lang} value={lang}>
                                        {languageMap[lang] || lang.toUpperCase()}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                {captionUrl && (
                    <FormGroup className="mb-3">
                        <Label>Caption URL</Label>
                        <Input
                            type="text"
                            value={captionUrl}
                            readOnly
                            className="form-control"
                        />
                    </FormGroup>
                )}
                <FormGroup>
                    <Label for="captionText">Caption Text</Label>
                    {loadingCaption ? (
                        <div className="text-center py-3">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2 text-muted">Loading caption...</p>
                        </div>
                    ) : (
                        <Input
                            type="textarea"
                            id="captionText"
                            rows="10"
                            placeholder={selectedCaptionFormat && selectedLanguage ? "Loading caption..." : "Select format and language to view caption"}
                            className="form-control"
                            value={captionText}
                            onChange={(e) => setCaptionText(e.target.value)}
                            readOnly={!isEditingCaption}
                        />
                    )}
                </FormGroup>
                <div className="text-end">
                    {!isEditingCaption ? (
                        <Button 
                            style={{ color: 'white', background: '#50c3e6', border: '#50c3e6' }} 
                            className="mt-3"
                            onClick={onEdit}
                            disabled={!captionText || loadingCaption}
                        >
                            Edit Caption
                        </Button>
                    ) : (
                        <div className="d-flex gap-2 justify-content-end mt-3">
                            <Button 
                                color="secondary"
                                onClick={onCancel}
                                disabled={savingCaption}
                            >
                                Cancel
                            </Button>
                            <Button 
                                style={{ color: 'white', background: '#50c3e6', border: '#50c3e6' }}
                                onClick={onSave}
                                disabled={savingCaption || !captionText}
                            >
                                {savingCaption ? 'Saving...' : 'Save Caption'}
                            </Button>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default CaptionEditor;

